/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path utils
 * @description Element type pages
 */
import { SearchResult } from "./../apihooks/useSearch";
import typenameToViewMap from "./../typenames/typenameToViewMap";
const getElementTypePage = (elem: SearchResult) => {
  if (elem.typename === "Milestone") {
    return {
      page: "project",
      meaId: elem.parent_id,
    };
  }
  if (elem.typename.indexOf("Government") >= 0) {
    return {
      page: "governmententity",
      meaId: elem.id,
    };
  }
  return {
    page: typenameToViewMap[elem.typename],
    meaId: elem.id,
  };
};
export default getElementTypePage;
